<template>
  <div>
    <v-container style="max-width: 1200px">
      <div
        style="
          border: 1px solid #d4d4d4;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          overflow: hidden;
        "
      >
        <v-toolbar flat color="#FFFFFF">
          <v-toolbar-title>Blog Posts</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn small text @click="showCategoriesDialog = true">
            <v-icon left>mdi-cog</v-icon>Manage Categories
          </v-btn>
          <v-btn small text @click="onNewPostClick()">
            <v-icon left>mdi-plus</v-icon>New Post
          </v-btn>
        </v-toolbar>
        <v-dialog
          v-model="showCategoriesDialog"
          width="600px"
          style="height: 600px"
          scrollable
        >
          <BlogCategoryManagement
            @close="showCategoriesDialog = false"
          ></BlogCategoryManagement>
        </v-dialog>
        <v-card elevation="0">
          <v-card-text>
            <div class="pa-3" v-if="blogPosts.length === 0">
              No blog posts found.
            </div>
            <v-list>
              <v-list-item
                v-for="post in blogPosts"
                :key="post.id"
                @click="editPost(post)"
                class="mb-2"
              >
                <UserAvatar
                  :avatarUrl="post.coverImageUrl"
                  :fullName="post.title"
                />
                <div>{{ post.title }}</div>
                <v-chip small class="ml-2" title="Post category">{{
                  post.blogCategory.name
                }}</v-chip>
                <v-spacer></v-spacer>
                <div class="mr-4">
                  {{ post.dateCreatedFormatted }} -
                  {{ post.published ? "Published" : "Draft" }}
                </div>
                <v-divider vertical></v-divider>
                <v-btn
                  icon
                  target="_blank"
                  :href="
                    'https://' +
                    selectedProject.computedDomain +
                    '/blog/' +
                    post.slug
                  "
                  @click="$event.stopPropagation()"
                  class="ml-4"
                >
                  <v-icon small>mdi-open-in-new</v-icon>
                </v-btn>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
        <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          scrollable
          transition="dialog-bottom-transition"
          style="height: 100vh"
        >
          <div v-if="selectedPost && dialog" style="height: 100vh">
            <v-app-bar color="primary" dark dense fixed elevation="0">
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>
                {{ type == "EDIT" ? "Edit Post" : "" }}
                {{ type == "CREATE" ? "New Post" : "" }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-divider vertical></v-divider>
                <v-tooltip bottom v-if="type == 'EDIT'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      dark
                      text
                      @click="tryPublishBlogPost()"
                      :loading="publishing"
                      :disabled="publishing"
                      v-on="on"
                      >Publish</v-btn
                    >
                  </template>
                  <span
                    >When you publish this blog post, your website will be
                    published.</span
                  >
                </v-tooltip>
                <v-divider vertical></v-divider>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      dark
                      text
                      @click="saveBlogPost()"
                      :loading="saving"
                      :disabled="saving"
                      v-on="on"
                      >Save Draft</v-btn
                    >
                  </template>
                  <span>Save draft of this blog post.</span>
                </v-tooltip>
                <v-divider vertical></v-divider>
                <v-menu :nudge-width="140" offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon color="white">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      dense
                      @click="tryUnpublishBlogPost()"
                      :disabled="!selectedPost.published || unpublishing"
                    >
                      <v-list-item-title>Unpublish</v-list-item-title>
                    </v-list-item>
                    <v-list-item dense @click="tryDeleteBlogPost()">
                      <v-list-item-title>Delete post</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar-items>
            </v-app-bar>
            <v-card height="100%" style="overflow-y: auto">
              <v-card-text style="padding-top: 40px">
                <div class="pa-3 mt-3" style="margin: auto; width: 800px">
                  <div class="d-flex" style="flex-direction: column">
                    <div>
                      <ImagePicker
                        :url="selectedPost.coverImageUrl"
                        @input="
                          selectedPost.coverImageUrl = $event;
                          onContentUpdate();
                        "
                        :modes="['LIBRARY', 'UPLOAD']"
                        defaultMode="UPLOAD"
                        tooltip="Cover Image"
                      ></ImagePicker>
                    </div>
                    <div>
                      <v-text-field
                        label="Post title"
                        v-model="selectedPost.title"
                        placeholder="Post title"
                        autocomplete="off"
                        dense
                        @input="onContentUpdate"
                        style="width: 500px"
                        class="mt-3"
                      ></v-text-field>
                      <v-text-field
                        label="Post slug"
                        v-model="selectedPost.slug"
                        placeholder="Post slug"
                        autocomplete="off"
                        dense
                        class="mt-3"
                        prefix="/blog/"
                        @input="onContentUpdate"
                        style="width: 400px"
                      ></v-text-field>
                      <div>
                        <small
                          >URL will be
                          {{
                            selectedProject.computedDomain +
                            "/blog/" +
                            selectedPost.slug
                          }}</small
                        >
                      </div>
                      <v-select
                        label="Category"
                        :items="blogCategories"
                        dense
                        outlined
                        v-model="selectedPost.blogCategoryId"
                        item-value="id"
                        item-text="name"
                        :error="selectedPost.blogCategoryId == 0 ? true : false"
                        :error-count="selectedPost.blogCategoryId == 0 ? 1 : 0"
                        style="width: 300px"
                        class="mt-3"
                      ></v-select>
                    </div>
                  </div>
                  <PostEditor
                    ref="editor"
                    :content="selectedPost.content"
                    @input="onContentUpdate($event)"
                  ></PostEditor>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-dialog>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import debounce from "lodash/debounce";
import PostEditor from "../../components/PostEditor";
import ImagePicker from "../../components/ImagePicker";
import BlogCategoryManagement from "../../components/project/BlogCategoryManagement";
import UserAvatar from "../../components/UserAvatar";
import projectMixin from "../../components/project/project-mixin";

export default {
  components: { PostEditor, ImagePicker, BlogCategoryManagement, UserAvatar },
  mixins: [projectMixin],
  computed: {
    ...mapState({
      blogPosts: (state) => state.project.blogPosts,
    }),
  },
  data() {
    return {
      dialog: false,
      content: "",
      selectedPost: null,
      type: "",
      publishing: false,
      unpublishing: false,
      saving: false,
      showCategoriesDialog: false,
    };
  },
  methods: {
    ...mapActions({
      getBlogPosts: "project/getBlogPosts",
      publishBlogPost: "project/publishBlogPost",
      unpublishBlogPost: "project/unpublishBlogPost",
      updateBlogPost: "project/updateBlogPost",
      createBlogPost: "project/createBlogPost",
      deleteBlogPost: "project/deleteBlogPost",
    }),
    editPost(post) {
      this.selectedPost = post;
      this.dialog = true;
      this.type = "EDIT";
    },
    async tryPublishBlogPost() {
      this.publishing = true;
      await this.saveBlogPost();
      await this.publishBlogPost(this.selectedPost.id);
      this.selectedPost.published = true;
      this.publishing = false;
    },
    async tryUnpublishBlogPost() {
      this.unpublishing = true;
      await this.unpublishBlogPost(this.selectedPost.id);
      this.selectedPost.published = false;
      this.unpublishing = false;
    },
    async tryDeleteBlogPost() {
      await this.deleteBlogPost(this.selectedPost.id);
      this.dialog = false;
    },
    async saveBlogPost() {
      this.saving = true;
      if (this.type == "EDIT") {
        await this.updateBlogPost({
          id: this.selectedPost.id,
          title: this.selectedPost.title,
          slug: this.selectedPost.slug,
          content: this.$refs.editor.getHTML(),
          coverImageUrl: this.selectedPost.coverImageUrl,
          blogCategoryId: this.selectedPost.blogCategoryId,
        });
      }
      if (this.type == "CREATE") {
        var resultPostId = await this.createBlogPost({
          title: this.selectedPost.title,
          slug: this.selectedPost.slug,
          content: this.$refs.editor.getHTML(),
          coverImageUrl: this.selectedPost.coverImageUrl,
          projectId: this.selectedPost.projectId,
          blogCategoryId: this.selectedPost.blogCategoryId,
        });
        if (resultPostId) {
          this.selectedPost.id = resultPostId;
          this.type = "EDIT";
        }
      }
      this.saving = false;
    },
    onNewPostClick() {
      var blogCategoryId = 0;
      if (this.blogCategories.length > 0) {
        blogCategoryId = this.blogCategories[0].id;
      }
      this.selectedPost = {
        title: "Hello World",
        slug: "hello-world",
        content:
          "<p>Hey!</p><p>This is your <strong>first</strong> blog post. Edit and publish it. When you publish this post, your whole site is going to be published.</p><p></p>",
        coverImageUrl: "",
        projectId: this.selectedProject.id,
        blogCategoryId,
      };
      this.dialog = true;
      this.type = "CREATE";
    },
    onContentUpdate: debounce(function () {
      // this.saveBlogPost();
    }, 500),
  },
  created() {
    this.getBlogCategories();
    this.getBlogPosts(this.selectedProject.id);
  },
};
</script>